module.exports = __webpack_public_path__ + "img/image-video-thumbnail-1.0928b5b.jpg";